import { ApprovalForm } from './formApprovalTypes';

export enum StateForm {
  Draft = 0,
  Published = 1,
  Unpublished = 2,
  Archived = 3,
}

// export enum StateInvitation {
//   Opened = 0,
//   InProgresse = 1,
// }

export enum LevelAdmin {
  All = 0,
  Update = 1,
  Delete = 2,
}

// export enum ApprovalType {
//   Departement = 0,
//   Site = 1,
// }

export enum FieldType {
  Number = 0,
  Description = 1,
  Text = 2,
  Email = 3,
  Password = 4,
  Date = 5,
  Time = 6,
  Checkbox = 7,
  Radio = 8,
  Select = 9,
  TextArea = 10,
  File = 11,
  Hidden = 12,
  Url = 13,
  Tel = 14,
  DateTime = 15,
  Color = 16,
  DateRange = 17,
  TimeRange = 18,
  InputFile = 19,
}

export enum FormType {
  Template = 0,
  Form = 1,
}

export enum StepStatutForm {
  Active = 0,
  Finish = 1,
}

export enum FormShareType {
  Public = 0,
  Society = 1,
  Department = 2,
  Function = 3,
  Employee = 4,
  Site = 5,
  Company = 6,
}

export enum FormUsage {
  Global = 0,
  Recovery = 1,
}

export interface FieldForm {
  id: number;
  fieldTypeString?: string;
  fieldType: FieldType;
  title?: string;
  sectionId: number;
  description?: string;
  isRequired: boolean;
  locked: boolean;
  code?: string;
  showInDataTable: boolean;
  hideTitle: boolean;
  order: number;
  sectionTitle?: string;
  values?: string;
  oldValues?: string;
  response?: string;
  sourceItems?: string | SelectItem[];
  usePredefinedList: boolean;
  temp: boolean;
  listValues?: string[];
  filesNames?: File[] | FileItem[];
  valuePath?: string;
  uploadedFiles?: File[];
}

export interface FileItem {
  id?: number;
  name: string;
  lastModified?: number;
  path?: string;
  mimetype?: string;
}

export interface ExistingFile {
  id: number;
  name: string;
  path: string;
  doc?: boolean;
  mimetype?: string;
  userId?: number | null;
}

export interface SortableFieldForm extends FieldForm {
  chosen: boolean;
  selected: boolean;
}

export interface CleanFieldForm {
  id: number;
  fieldTypeString?: string;
  fieldType: FieldType;
  title?: string;
  sectionId: number;
  description?: string;
  isRequired: boolean;
  locked: boolean;
  code?: string;
  showInDataTable: boolean;
  hideTitle: boolean;
  sectionTitle?: string;
  values?: string | string[];
  oldValues?: string;
  response?: string;
  sourceItems?: string | SelectItem[];
  usePredefinedList: boolean;
  temp: boolean;
  listValues?: string[];
}

export interface ApprovalFormLevel {
  id: number;
  typeLevel?: string;
  levelTypeList?: SelectItem[];
  fk_Approval?: number;
  fk_User?: string;
  usersIds?: string[];
  userName?: string;
  usernames?: string[];
}

// export interface ApprovalFormLevelGrouped {
//   statutName?: string;
//   levelCount: number;
//   approvalFormLevel?: ApprovalFormLevel[];
// }

// export interface ApprovalForm {
//   id: number;
//   approvalType?: string;
//   isRespectOrder: boolean;
//   canDeleted: boolean;
//   approvalFormLevelGrouped?: ApprovalFormLevelGrouped[];
// }

export interface Status {
  id: number;
  title?: string;
  statut: boolean;
  color?: string;
  formId?: number;
  order?: number;
  finishStep: boolean;
  locked: boolean;
  step: StepStatutForm;
  isRejected: boolean;
  activedStatut: boolean;
  activedApproval: boolean;
  totalAffected: number;
}

export interface FormEdit {
  id: number;
  title?: string;
  iconPath?: string;
  description?: string;
  isArchived: boolean;
  countAdmins: number;
  state: StateForm;
  type: FormType;
  usage: FormUsage;
  shareWith: FormShareType;
  affectTo: FormShareType;
  fields?: FieldForm[];
  activedStatut: boolean;
  activedApproval: boolean;
  isPrimary: boolean;
  approvalForms?: ApprovalForm[];
  statuts?: Status[];
  statePublished?: string;
  totalResponse: number;
  isAnonymous: boolean;
  sourcesItems?: SelectItem[];
  affectedAdmins?: SelectItem[];
  noAffectedAdmins?: SelectItem[];
  adminId?: string[];
}
